/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CellValue } from "./CellValue";
export const RecordData = core.serialization.record(core.serialization.string(), CellValue);
